import React from "react";
import styled from "styled-components";
import { Spin } from "antd";

const StyledSpin = styled(Spin)`
  margin: 0;
  position: absolute;
  top: 48%;
  left: 48%;
`;

const FullPageLoader = () => {
  return <StyledSpin tip="Loading..." size="large" />;
};

export default FullPageLoader;
